module.exports = {
    sectionDescription: (value = "") => `
        <div class="section-description-container">
            ${value.replace(/(\r\n|\n|\r)/gm, '<br>')}
        </div>
        `
}